import styled from 'styled-components';
import { getColorFromSlug } from 'utility/colors';
import { screenWidth } from 'utility/screen-width';

export const StyledLink = styled.a`
    color: ${getColorFromSlug('david-yellow')} !important;
    background: ${getColorFromSlug('david-black')};
    border-radius: 5px;
    padding: 0 10px;
    height: 40px;
    font-size: 18px;
    font-family: 'Oswald', serif;
    width: 100%;
    min-width: 125px;
    border: 2px solid ${getColorFromSlug('david-black')};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover, &:focus {
        background: ${getColorFromSlug('dark-gray')};
    }

    @media ${screenWidth.below.sm} {
        font-size: 16px;
    }
`;
